import { useDispatch, useSelector } from "react-redux";
import ICAMEX from "../../assets/icons/ICAMEX";
import ICFacebook from "../../assets/icons/ICFacebook";
import ICHotline from "../../assets/icons/ICHotline";
import ICInstagram from "../../assets/icons/ICInstagram";
import ICJCB from "../../assets/icons/ICJCB";
import ICLocation from "../../assets/icons/ICLocation";
import ICMail from "../../assets/icons/ICMail";
import ICMaster from "../../assets/icons/ICMaster";
import ICVisa from "../../assets/icons/ICVisa";
import ButtonOutlineSmall from "../Button/ButtonOutlineSmall";
import TextFiled from "../Input/TextFiled";

import "./Footer.scss";
import { useNavigate } from "react-router-dom";
import { stringToUrl } from "../../utils/url.utils";
import ButtonDropdown from "../ButtonDropdown/ButtonDropdown";
import i18next from "i18next";
import { useEffect, useState } from "react";

const lngs = {
  en: { nativeName: 'english' },
  vi: { nativeName: 'vietnamese' }
};

const Footer = () => {
  const { dataProductCategory } = useSelector(
    (state) => state.dataProductCategory
  );

  const navigate = useNavigate();
  const [lng, setLng] = useState(localStorage.getItem("i18nextLng")?.slice(0,2))

  return (
    <footer>
      <div className="footer">
        <div className="footer--info">
          <div className="footer--info-title">
            <span>{i18next.t("footer.info")}</span>
          </div>
          <div className="footer--info--content">
            <div className="footer--info--content-value">
              <div style={{ width: "16px" }}>
                <ICHotline width={16} height={16} />
              </div>
              <span>0941 446 571</span>
              <span>{i18next.t("footer.onSite")}</span>
            </div>
            <div className="footer--info--content-value">
              <div style={{ width: "16px" }}>
                <ICLocation width={16} height={16} />
              </div>
              <span>{i18next.t("footer.address")}</span>
            </div>
            {/* <div className="footer--info--content-value">
              <ICLocation width={16} height={16} />
              <span>KDC Trung Sơn, Bình Chánh</span>
            </div> */}
            <a
              className="footer--info--content-value"
              href="mailto:lanhainfo@gmail.com"
            >
              <div style={{ width: "16px" }}>
                <ICMail width={16} height={16} />
              </div>
              <span>lanhainfo@gmail.com</span>
            </a>
          </div>
        </div>
        <div className="footer--orther">
          <div className="footer--orther-title">
            <span>{i18next.t("footer.product")}</span>
          </div>
          <div className="footer--orther--content">
            {dataProductCategory?.categoryFilter?.map((category) => (
              <div
                key={category?._id}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/sofa/${stringToUrl(category?.title)}`);
                }}
                className="footer--orther--content-name hover-underline-animation"
                style={{ textTransform: "uppercase" }}
              >
                <span>{category?.title}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="footer--orther">
          <div className="footer--orther-title">
            <span>{i18next.t("footer.service")}</span>
          </div>
          <div className="footer--orther--content">
            <div className="footer--orther--content-name hover-underline-animation" onClick={(e) => {
              e.stopPropagation();
              navigate(`/dieu-khoan-chinh-sach`);
            }}>
              <span>{i18next.t("footer.termsOfUse")}</span>
            </div>
            <div className="footer--orther--content-name hover-underline-animation" onClick={(e) => {
              e.stopPropagation();
              navigate(`/dieu-khoan-chinh-sach`);
            }}>
              <span>{i18next.t("footer.privacyPolicy")}</span>
            </div>
            <div
              className="footer--orther--content-name hover-underline-animation"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/dieu-khoan-chinh-sach`);
              }}
            >
              <span>{i18next.t("footer.returnPolicy")}</span>
            </div>
            <div className="footer--orther--content-name hover-underline-animation" onClick={(e) => {
              e.stopPropagation();
              navigate(`/faq`);
            }}>
              <span>FAQ</span>
            </div>
          </div>
        </div>
        <div className="footer--social">
          <div className="footer--social-title">
            <span>{i18next.t("footer.followUs")}</span>
          </div>
          <div className="footer--social--content">
            <a
              className="footer--social--content--container"
              href="https://www.facebook.com/lanhadecor.vn/"
              target="_blank" rel="noreferrer"
            >
              <ICFacebook width={32} height={32} />
              <div className="footer--social--content--container-name">
                <span>Facebook</span>
              </div>
            </a>
            <a
              className="footer--social--content--container"
              href="https://www.instagram.com/decor.lanha/profilecard/?igsh=OWF5MWJkMW9rZ2Zq"
              target="_blank" rel="noreferrer"
            >
              <ICInstagram width={32} height={32} />
              <div className="footer--social--content--container-name">
                <span>Instagram</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer--left">
          <div className="footer--left-name">Là Nhà Decor</div>
        </div>
        <div className="footer--right">
          <div className="footer--right-title">
            {i18next.t("footer.info.offer")}
          </div>
          <div className="footer--right-content">
            <TextFiled placeholder={"@gmail.com"} />
            <ButtonOutlineSmall title={i18next.t("footer.signup")} style={{ flex: "none" }} />
          </div>
        </div>
        <div className="footer--right" style={{ width: "fit-content" }}>
          <div className="footer--right-title">
            {i18next.t("footer.language")}
          </div>
          <div className="footer--right-content">
            <ButtonDropdown
              isHidden={true}
              isShowUp={true}
              title={i18next.t(lngs[lng].nativeName)}
              id={"DropdownChangeLanguage"}
              container={<div className="list--option--sort">
                {Object.keys(lngs).map((ln) => (
                  <div
                    key={ln}
                    className={`option--sort ${ln === lng && "active"
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLng(ln)
                      i18next.changeLanguage(ln);
                      window.location.reload();
                    }}
                  >
                    {i18next.t(lngs[ln].nativeName)}
                  </div>
                ))}
              </div>} />
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="copyright--content">
          <span>Copyright © 2024 Là Nhà Decor. All Rights Reserved</span>
        </div>
        <div className="copyright--bank">
          <ICVisa />
          <ICMaster />
          <ICJCB />
          <ICAMEX />
        </div>
      </div>
    </footer>
  );
};
export default Footer;
